/* src/app/footer/footer.component.scss */
footer {
  position: relative;
  bottom: 0;
}
/*# sourceMappingURL=footer.component.css.map */
